import { render, staticRenderFns } from "./VerifyEmailModal.vue?vue&type=template&id=706b7838&scoped=true&"
import script from "./VerifyEmailModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VerifyEmailModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VerifyEmailModal.vue?vue&type=style&index=0&id=706b7838&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706b7838",
  null
  
)

export default component.exports